"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPartialLCDMessageRecord = exports.minmalBOToVob = exports.vobToMinimalBO = exports.deviceToIoTVLCDDeviceRecord = exports.deviceToMinimalBO = exports.LinkType = void 0;
var LinkType;
(function (LinkType) {
    LinkType["UP"] = "UP";
    LinkType["DOWN"] = "DOWN";
})(LinkType || (exports.LinkType = LinkType = {}));
const deviceToMinimalBO = (item) => {
    const { id, type, name, eui, deviceId, deviceType, networkKey, appID } = item;
    return { id, type, name, eui, deviceId, deviceType, networkKey, appID };
};
exports.deviceToMinimalBO = deviceToMinimalBO;
const deviceToIoTVLCDDeviceRecord = (item) => {
    const { dailyFCntSkip, dailyMessageCount, yesterdaysFCntJumpTotal, yesterdaysMessageCntTotal } = item;
    return { ...(0, exports.deviceToMinimalBO)(item), dailyFCntSkip, dailyMessageCount, yesterdaysFCntJumpTotal, yesterdaysMessageCntTotal };
};
exports.deviceToIoTVLCDDeviceRecord = deviceToIoTVLCDDeviceRecord;
const vobToMinimalBO = (item) => {
    const { id, type, name } = item;
    return { id, type, name };
};
exports.vobToMinimalBO = vobToMinimalBO;
const minmalBOToVob = (item) => {
    const { id, type, name } = item;
    const key = `${type}:${id}`;
    return { sk: key, pk: key, id, type, name };
};
exports.minmalBOToVob = minmalBOToVob;
const getPartialLCDMessageRecord = () => {
    return {
        customerID: undefined,
        nwID: undefined,
        gwEUI: undefined,
        gwLong: undefined,
        gwLat: undefined,
        gwStatus: undefined,
        gwLastSeen: undefined,
        devID: undefined,
        devEUI: undefined,
        devStatus: undefined,
        devLastSeen: undefined,
        devGroup: undefined,
        devBGroup: undefined,
        devType: undefined,
        devLat: undefined,
        devLong: undefined,
        devBattery: undefined,
        devMessagePeriod: undefined,
        devBatteryCharging: undefined,
        devReboot: undefined,
        devDownlinkAck: undefined,
        devBbatteryErr: undefined,
        devLinkCheckErr: undefined,
        devJoinCount: undefined,
        DevMessUpCount: undefined,
        DevMessDownCount: undefined,
        recpPort: undefined,
        recpChannel: undefined,
        mRSSI: undefined,
        mSNR: undefined,
        ESP: undefined,
        recpDist: undefined,
        devGateways: undefined,
        messTime: undefined,
        mType: undefined,
        messSF: undefined,
        messChain: undefined,
        mPayloadSize: undefined,
    };
};
exports.getPartialLCDMessageRecord = getPartialLCDMessageRecord;
